import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import theme from "../../themes/theme";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    padding: "10px 00px",
    backgroundColor: theme.palette.background.light,
    border: "1px solid #b7b7b755",
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: theme.palette.text.dark,
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: 0,
    },
    "& .MuiMenuItem-root": {
      color: theme.palette.text.dark,
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.dark,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
    "& .MuiDivider-root": {
      marginTop: '2px',
      marginBottom: '2px',
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

const Dropdown = ({ anchorEl, handleClose, data }) => {
  const open = Boolean(anchorEl);

  return (
    <StyledMenu
      id="demo-customized-menu"
      MenuListProps={{
        "aria-labelledby": "demo-customized-button",
      }}
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
    >
      {data?.map((d, i) => (
        <React.Fragment key={i}>
          <MenuItem
            sx={{
              display: "flex",
              justifyContent: "center",
              cursor: d.disableHover ? "default": "pointer",
              gap: 3,
              ...d.sx,
              "&:hover": {
                backgroundColor: d.disableHover ? theme.palette.background.light : theme.palette.primary.hover,
              },
            }}
            onClick={d.onClick}
            disableRipple
          >
            {d.title}
            {d.icon === "more" && <ArrowForwardIosIcon />}
          </MenuItem>
          {i !== data.length - 1 && (
            <Divider sx={{ width: "90%", justifySelf: "center" }} />
          )}
        </React.Fragment>
      ))}
    </StyledMenu>
  );
};

export default Dropdown;
